import { ChangeEvent } from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

import { c1F1F3A, c56EA99, cEA135E, cFFFFFF } from '#/colors';
import { OrderSide } from '#/api/orders';
import {
  useOrderFormActions,
  useOrderFormView,
} from '#/features/options/order-builder/form-context';

export default function TradeSidePicker() {
  const formView = useOrderFormView();
  const formActions = useOrderFormActions();

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    formActions.updateSide(e.currentTarget.value as OrderSide);
  };

  return (
    <Container>
      <TradeSide
        aria-label="short"
        aria-checked={formView.side === 'SELL'}
        value="SELL"
        onChange={handleChange}
      />
      <TradeSide
        aria-label="long"
        aria-checked={formView.side === 'BUY'}
        value="BUY"
        onChange={handleChange}
      />
    </Container>
  );
}

const Container = styled.div.attrs({
  role: 'radiogroup',
  'aria-label': 'trade side',
})`
  display: flex;
  gap: 12px;

  & > * {
    flex-grow: 1;
  }
`;

const TradeSide = styled.input.attrs({
  type: 'radio',
  name: 'trade-side',
})`
  appearance: none;

  cursor: pointer;
  background-color: ${c1F1F3A};
  color: ${rgba(cFFFFFF, 0.5)};
  border: 1px solid transparent;
  height: 40px;
  padding: 0 16px;
  border-radius: 5px;
  display: grid;
  place-items: center;
  text-transform: capitalize;

  &[aria-checked='true'] {
    ${({ value }) => {
      const primaryColor = value === 'SELL' ? cEA135E : c56EA99;

      return `
        color: ${primaryColor};
        border: 1px solid ${primaryColor};
      `;
    }}
  }

  &:after {
    content: '${(props) => props['aria-label']}';
  }
`;
